'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reviewModal = require('../actions/review-modal');

var INITIAL_STATE = {
	profileName: '',
	profileImage: '',
	isOpen: false,
	isCodeValid: false,
	validationFailed: false,
	pageOneActive: true,
	pageTwoActive: false,
	pageThreeActive: false,
	agreeButtonActive: false,
	starSelected: false,
	isReviewEmpty: true,
	submitAttempted: false,
	nextButtonActive: false,
	activeStar: 0,
	reviewData: {
		patient: null,
		author: false,
		attributes: null
	},
	scrollDisabled: false,
	uriId: ''
};

var reviewModal = function reviewModal(state, action) {
	switch (action.type) {
		case _reviewModal.OPEN_REVIEW_MODAL:
			return Object.assign({}, state, { isOpen: true });
		case _reviewModal.CLOSE_REVIEW_MODAL:
			return Object.assign({}, state, INITIAL_STATE);
		case _reviewModal.AGREE_BUTTON_CLICKED:
			return Object.assign({}, state, { agreeButtonActive: !state.agreeButtonActive });
		case _reviewModal.VALIDATE_CODE + '_REQUESTED':
			return Object.assign({}, state, { reviewData: _extends({}, state.reviewData, { review_code: action.actionData }), validationFailed: false, validatingCode: true });
		case _reviewModal.VALIDATE_CODE + '_RECEIVED':
			{
				var profile = action.response.specialist || action.response.practice;
				return Object.assign({}, state, {
					isCodeValid: true,
					validationFailed: false,
					pageTwoActive: true,
					pageOneActive: false,
					reviewData: _extends({}, state.reviewData, {
						id: profile.id
					}),
					profileName: profile.name,
					profileImage: profile.attributes && action.response.specialist && profile.attributes.profile_featured_image && profile.attributes.profile_featured_image + '_lg.jpg' || profile.attributes && action.response.practice && profile.attributes.profile_logo && profile.attributes.profile_logo + '_lg.jpg' || null,
					uriId: profile.uri_id,
					profileType: action.response.specialist && 'specialist' || 'practice',
					validatingCode: false
				});
			}
		case _reviewModal.VALIDATE_CODE + '_FAILED':
			return Object.assign({}, state, { isCodeValid: false, validationFailed: true, validatingCode: false });
		case _reviewModal.NEXT_BUTTON_CLICKED:
			return Object.assign({}, state, { nextButtonActive: true });
		case _reviewModal.SET_STAR_ACTIVE:
			return Object.assign({}, state, { reviewData: _extends({}, state.reviewData, { rating: action.rating }), activeStar: action.rating, starSelected: true });
		case _reviewModal.SUBMIT_ATTEMPTED:
			return Object.assign({}, state, { submitAttempted: true, pageThreeActive: false, pageTwoActive: true, pageOneActive: false });
		case _reviewModal.SUBMIT_BUTTON_CLICKED + '_RECEIVED':
			return Object.assign({}, state, {
				pageThreeActive: true, pageTwoActive: false, pageOneActive: false, submitAttempted: true
			});
		case _reviewModal.REVIEW_BODY_CHANGE:
			if (action.body.length > 0) {
				return Object.assign({}, state, { reviewData: _extends({}, state.reviewData, { body: action.body }), isReviewEmpty: false });
			} else {
				return Object.assign({}, state, { reviewData: _extends({}, state.reviewData, { body: '' }), isReviewEmpty: true });
			}
		case _reviewModal.REVIEW_CODE_CHANGE:
			{
				if (action.code.length > 0) {
					return Object.assign({}, state, { reviewData: _extends({}, state.reviewData), reviewCode: action.code });
				} else {
					return Object.assign({}, state, { reviewData: _extends({}, state.reviewData), reviewCode: '' });
				}
			}
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = reviewModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/review-modal.js
// module id = 1690
// module chunks = 0